import * as React from 'react';
import { cn } from '../cn';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padded?: boolean;
  interactive?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(function Card({ className, padded = true, interactive, ...props }, ref) {
  return <div ref={ref} className={cn('bg-surface rounded-[var(--radius-lg)] shadow-[var(--shadow-sm)]', padded && 'p-5', interactive && 'transition-[box-shadow,transform] duration-[var(--duration)] hover:shadow-[var(--shadow)] hover:-translate-y-px', className)} {...props} />;
});

export function CardHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex items-start justify-between gap-4 mb-4', className)} {...props} />;
}
export function CardTitle({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('text-[15px] font-semibold tracking-[-0.01em] text-text', className)} {...props} />;
}
export function CardDescription({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('text-[13px] text-text-2 mt-0.5', className)} {...props} />;
}
export function CardContent({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('text-[14px]', className)} {...props} />;
}
export function CardFooter({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex items-center justify-end gap-2 mt-4 pt-4 hairline-t', className)} {...props} />;
}
